export const isBot = (ua: string) => /bot|crawl|spider|slurp|bing|duckduck|baiduspider|yandex/i.test(ua || '');
